import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";

export const ADD_PAGE = 'ADD_PAGE';
export const SAVE_PAGE = 'SAVE_PAGE';

export const ADD_FEED_POSTS = 'ADD_FEED_POSTS'
export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
export const GET_FEEDS_SUCCESS = 'GET_FEEDS_SUCCESS';
export const GET_FEEDS_POSTDATA = 'GET_FEEDS_POSTDATA';
export const GET_SHARED_SUCCESS = 'GET_SHARED_SUCCESS';
export const TOGGLE_NO_MORE_POST = 'TOGGLE_NO_MORE_POST';
export const TOGGLE_NO_MORE_FEED = 'TOGGLE_NO_MORE_FEED';
export const TOGGLE_NO_MORE_SHARED = 'TOGGLE_NO_MORE_SHARED';
export const DELETE_POST = 'DELETE_POST';
export const GET_CHANGE='GET_CHANGE';
export const SHAREDTOME_COUNT = 'SHAREDTOME_COUNT';

export const getUserReflectionsFetch = (page) => {
      
    return (dispatch) => {
        axios.get(serverUrl.Reflections + `?_page=${page}&_limit=5`)
            .then((response) => {
                if (response.data.results.length < 5) {
                    dispatch({ type: TOGGLE_NO_MORE_POST, reflections: response.data.results });
                } else {
                    dispatch({ type: GET_POSTS_SUCCESS, reflections: response.data.results });
                }
            });
    }
}

export const addFeedPosts = (posts) => {
      
    return dispatch => {
        dispatch({
            type: ADD_FEED_POSTS,
            payload: posts
        });
    }
}

export const getCommunityFeed = (offset,is_Tutor,is_student,limit=20) => {
      
    return dispatch => {
        axios.get(serverUrl.Community + `?offset=${offset}&is_tutor=${is_Tutor}&limit=${limit}&is_student=${is_student}`)
            .then(resp => {
                if (resp.status === 200) {
                    const feeds = resp.data.posts
                    const groups = resp.data.groups
                    dispatch({
                        type: (feeds.length < 5) ? TOGGLE_NO_MORE_FEED : GET_FEEDS_SUCCESS,
                        payload: { feeds, groups }
                    });
                }
            })
    }
}


export const getCommunityPersonal = (page) => {
      
    return dispatch => {
        axios.get(serverUrl.CommunityPersonal + `?_page=${page}&_limit=20`)
            .then(resp => {
                if (resp.status === 200) {
                    const feeds = resp.data.posts
                    const groups = resp.data.groups
                    dispatch({
                        type: (feeds.length < 20) ? TOGGLE_NO_MORE_FEED : GET_FEEDS_SUCCESS,
                        payload: { feeds, groups }
                    });
                }
            })
    }
}

export const getGroupFeed = (groupId) => {
      
    return dispatch => {
        axios.get(serverUrl.Communityv2 + `/group/${groupId}`)
            .then(resp => {
                if (resp.status === 200) {
                    let data = {
                        group_name: resp.data?.group_name,
                        can_post: resp.data?.can_post
                    }
                    const feeds = resp.data?.posts;
                    dispatch({
                        type: (feeds.length < 5) ? TOGGLE_NO_MORE_FEED : GET_FEEDS_SUCCESS,
                        payload: { feeds }
                    });
                    dispatch({
                        type: GET_FEEDS_POSTDATA,
                        payload: { data }
                    });
                }
            })
    }
}

export const getCommunityShared = (offset) => {
    return dispatch => {
        axios.get(serverUrl.CommunityShared+`?offset=${offset}`)
            .then(resp => {
                if (resp.status === 200) {
                    const sharedPosts = resp.data.reflections

                    dispatch({
                        type: (sharedPosts.length < 20) ? TOGGLE_NO_MORE_SHARED : GET_SHARED_SUCCESS,
                        payload: { sharedPosts }
                    });
                    if (sharedPosts?.length == 0){
                        dispatch({ type: SHAREDTOME_COUNT, payload : false})
                    }else {
                        dispatch({ type: SHAREDTOME_COUNT, payload : true})
                    }
                }
            })
    }
}

export const deletePost = (group_id, post_id) => {
      
    return dispatch => {
        dispatch({
            type: DELETE_POST,
            payload: { group_id, post_id }
        });
    }
}

export const getChange =(change)=>{
    return {type: GET_CHANGE,
    payload:{change}}
}